(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-incanto"]) return;
  try {
    
  (function () {
    function stopOthers(current) {
      document.querySelectorAll('.ib-video').forEach(function (c) {
        var v = c.querySelector('video');
        if (v && v !== current) { v.pause(); c.classList.remove('is-playing'); }
      });
    }

    function toggle(card) {
      var v = card.querySelector('video');
      if (!v) return;
      if (v.paused) {
        stopOthers(v);
        v.muted = false;
        v.play();
        card.classList.add('is-playing');
      } else {
        v.pause();
        card.classList.remove('is-playing');
      }
    }

    document.addEventListener('click', function (e) {
      var card = e.target.closest('.ib-video');
      if (card) toggle(card);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest && e.target.closest('.ib-video');
      if (card) { e.preventDefault(); toggle(card); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
